import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AssistantLauncher } from '@foodamigos/ui/dashboard';
import { actionCreators } from '../../store/actions';
import usePlatformAgentState from '../../hooks/context/usePlatformAgentState';
import usePlatformAgentUnread from '../../hooks/platform-agent/usePlatformAgentUnread';
import { PLATFORM_AGENT_NAMES } from '../../services/platform-agent/platformAgent';
import amigoFace from '../../resources/assets/images/platform-agent/amigo-face.png';

/**
 * Ask Amigo (a partner's dashboard: Assistant), bottom right on every page. With news while the panel was closed, a
 * count of the answers the person hasn't seen, in its name too, and a rising count sends the beam round once
 * (usePlatformAgentUnread). Muted, with the reason in its tooltip, while the agent can't be reached; AssistantLauncher
 * then ignores clicks itself. Amigo's face is its image icon (28 px, round); a partner's assistant keeps the Sparkles.
 */
export default function PlatformAgentButton({ ref, ...props }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:PlatformAgent:PlatformAgentButton' });
  const dispatch = useDispatch();
  const { unavailable, name } = usePlatformAgentState();
  const { unread, attention } = usePlatformAgentUnread();
  // "Ask Amigo, 2 new" in the dashboard's language.
  const labels = useMemo(() => ({ unread: (_, count) => t(`label_unread.${name}`, { count }) }), [t, name]);

  return (
    <AssistantLauncher
      ref={ref}
      {...props}
      label={t(`label.${name}`)}
      iconSrc={name === PLATFORM_AGENT_NAMES.Amigo ? amigoFace : undefined}
      labels={labels}
      unread={unread}
      attention={attention}
      unavailable={unavailable}
      unavailableLabel={t(`unavailable_label.${name}`)}
      unavailableText={t(`unavailable_text.${name}`)}
      onClick={() => dispatch(actionCreators.platformAgent.open())}
    />
  );
}
